<template>
    <section v-if="!isLoading" id="Page" class="detail app-width cf pdg" data-pdgb="80" data-offer="true">
        <div class="title">{{ localizer.get("App.Common.Profile") }}</div>
        <div class="account">
            <div class="form">
                <div class="item">
                    <fieldset class="fieldset mrg" data-mrgt="20" data-row="2" :disabled="isLoadingForm">
                        <legend class="legend">{{ localizer.get("Checkout.Common.ProfileData") }}</legend>
                        <div class="form-items cf">
                            <div class="form-items" data-type="cols">
                                <div class="item">
                                    <div class="control">
                                        <label for="Name" class="label">{{ localizer.get("Checkout.Common.Profile_Name") }}</label>
                                        <input type="text" id="Name" v-model.lazy="formData.name" :class="[{ 'input-validation-error': isValidationError('Name') }, 'textbox']" />
                                        <span class="valid-sign">*</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="control">
                                        <label for="Surname" class="label">{{ localizer.get("Checkout.Common.Profile_Surname") }}</label>
                                        <input type="text" id="Surname" v-model.lazy="formData.surname" :class="[{ 'input-validation-error': isValidationError('Surname') }, 'textbox']" />
                                        <span class="valid-sign">*</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="control">
                                        <div class="control">
                                            <label for="ProfileTaxType" class="label">{{ localizer.get("Checkout.Common.Profile_ProfileTaxTypes") }}</label>
                                            <select id="ProfileTaxType" v-model.lazy="formData.profileTaxType" :class="[{ 'input-validation-error': isValidationError('ProfileTaxType') }, 'dropdown']">
                                                <option :value="null">...</option>
                                                <option v-for="(profileTaxType, index) in profileTaxTypes" :value="profileTaxType.value" :key="index">
                                                    {{ profileTaxType.title }}
                                                </option>
                                            </select>
                                            <span class="valid-sign">*</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="control">
                                        <label for="TaxCode" class="label">{{ localizer.get("Checkout.Common.Profile_TaxCode") }}</label>
                                        <input type="text" id="TaxCode" v-model.lazy="formData.taxCode" :class="[{ 'input-validation-error': isValidationError('TaxCode') }, 'textbox']" />
                                        <span v-if="formData.country === 'IT' && formData.profileTaxType !== 'LegalPerson'" class="valid-sign">*</span>
                                    </div>
                                </div>
                                <template v-if="formData.profileTaxType == 'LegalPerson'">
                                    <div class="item companydata" data-type="std">
                                        <div class="control">
                                            <label for="Company" class="label">{{ localizer.get("Checkout.Common.Profile_Company") }}</label>
                                            <input type="text" id="Company" v-model.lazy="formData.company" :class="[{ 'input-validation-error': isValidationError('Company') }, 'textbox']" />
                                            <span class="valid-sign">*</span>
                                        </div>
                                    </div>
                                    <div class="item companydata" data-type="std">
                                        <div class="control">
                                            <label for="IVACode" class="label">{{ localizer.get("Checkout.Common.Profile_IVACode") }}</label>
                                            <input type="text" id="IVACode" v-model.lazy="formData.ivaCode" :class="[{ 'input-validation-error': isValidationError('IVACode') }, 'textbox']" />
                                            <span class="valid-sign">*</span>
                                        </div>
                                    </div>
                                    <div class="item companydata" v-if="formData.country === 'IT'">
                                        <div class="control">
                                            <label for="SDICode" class="label">{{ localizer.get("Checkout.Common.Profile_SDICode") }}</label>
                                            <input type="text" id="SDICode" v-model.lazy="formData.sdiCode" :class="[{ 'input-validation-error': isValidationError('SDICode') }, 'textbox']" />
                                            <span class="valid-sign">*</span>
                                        </div>
                                    </div>
                                    <div class="item companydata" v-if="formData.country === 'IT'">
                                        <div class="control">
                                            <label for="CertifiedEmail" class="label">{{ localizer.get("Checkout.Common.Profile_CertifiedEmail") }}</label>
                                            <input type="text" id="CertifiedEmail" v-model.lazy="formData.certifiedEmail" :class="[{ 'input-validation-error': isValidationError('CertifiedEmail') }, 'textbox']" />
                                            <span class="valid-sign">*</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset class="fieldset mrg" data-mrgt="20" data-row="2" :disabled="isLoadingForm">
                        <div class="form-items">
                            <div class="item">
                                <div class="control">
                                    <label for="Address" class="label">{{ localizer.get("Checkout.Common.Profile_Address") }}</label>
                                    <input type="text" id="Address" v-model.lazy="formData.address" :class="[{ 'input-validation-error': isValidationError('Address') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item"></div>
                            <div class="item">
                                <div class="control">
                                    <label for="Location" class="label">{{ localizer.get("Checkout.Common.Profile_Location") }}</label>
                                    <input type="text" id="Location" v-model.lazy="formData.location" :class="[{ 'input-validation-error': isValidationError('Location') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="PostCode" class="label">{{ localizer.get("Checkout.Common.Profile_PostCode") }}</label>
                                    <input type="text" id="PostCode" v-model.lazy="formData.postCode" :class="[{ 'input-validation-error': isValidationError('PostCode') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="PostCode" class="label">{{ localizer.get("Checkout.Common.Profile_Country") }}</label>
                                    <select id="Country" v-model.lazy="formData.country" @change="getShippingModes()" :class="[{ 'input-validation-error': isValidationError('Country') }, 'dropdown']">
                                        <option :value="null">...</option>
                                        <option v-for="(country, index) in countries" :value="country.value" :key="index">
                                            {{ country.title }}
                                        </option>
                                    </select>
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div v-if="formData.country == 'IT'" class="item">
                                <div class="control">
                                    <label for="Zone" class="label">{{ localizer.get("Checkout.Common.Profile_Provinces") }}</label>
                                    <select id="Zone" v-model.lazy="formData.zone" :class="[{ 'input-validation-error': isValidationError('Zone') }, 'dropdown']">
                                        <option :value="null">...</option>
                                        <option v-for="(province, index) in provinces" :value="province.value" :key="index">
                                            {{ province.title }}
                                        </option>
                                    </select>
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div v-else></div>
                            <div class="item">
                                <div class="control">
                                    <label for="Email" class="label">{{ localizer.get("Checkout.Common.Profile_Email") }}</label>
                                    <input type="email" id="Email" v-model.lazy="formData.email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="Phone" class="label">{{ localizer.get("Checkout.Common.Profile_Phone") }}</label>
                                    <input type="tel" id="Phone" v-model.lazy="formData.phone" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset class="fieldset mrg" data-mrgt="20" data-row="2" :disabled="isLoadingForm">
                        <legend class="legend">{{ localizer.get("Checkout.Common.Profile_ContactData") }}</legend>
                        <div class="form-items" data-type="cols">
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingCO" class="label">{{ localizer.get("Checkout.Common.Profile_ShippingCO") }}</label>
                                    <input type="text" id="ShippingCO" v-model.lazy="formData.shippingCO" :class="[{ 'input-validation-error': isValidationError('ShippingCO') }, 'textbox']" />
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingPhone" class="label">{{ localizer.get("Checkout.Common.Profile_Phone") }}</label>
                                    <input type="tel" id="ShippingPhone" v-model.lazy="formData.shippingPhone" :class="[{ 'input-validation-error': isValidationError('ShippingPhone') }, 'textbox']" />
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingNotes" class="label">{{ localizer.get("Checkout.Common.Profile_Note") }}</label>
                                    <input type="tel" id="ShippingNotes" v-model.lazy="formData.shippingNotes" :class="[{ 'input-validation-error': isValidationError('ShippingNotes') }, 'textbox']" />
                                </div>
                            </div>
                            <div class="item"></div>
                        </div>
                    </fieldset>
                    <fieldset class="fieldset mrg" data-mrgt="20" data-row="2" :disabled="isLoadingForm">
                        <legend class="legend">{{ localizer.get("Checkout.Common.Profile_ShippingData") }}</legend>
                        <div class="form-items" data-type="cols">
                            <div class="item">
                                <div class="control">
                                    <label class="label" for="ShippingMode">{{ localizer.get("Checkout.Common.Profile_ShippingMode") }}</label>
                                    <select id="ShippingMode" v-model.lazy="formData.shippingMode" :disabled="!formData.country" :class="[{ 'input-validation-error': isValidationError('ShippingMode') }, 'dropdown']">
                                        <option :value="null">...</option>
                                        <option v-for="(shippingMode, index) in shippingModes" :value="shippingMode.value" :key="index">
                                            {{ shippingMode.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="shipping-notes">
                                <div v-if="formData.shippingMode === 'ExWork'" id="shipping-exwork-note">{{ localizer.get("Checkout.Common.Shipping_ExWork_Note") }} <a :href="routes.Support_ShippingReturns + '#ExWorks'" class="link">{{ localizer.get("App.Common.ShippingExWork_More") }}</a></div>
                                <div v-if="formData.shippingMode === 'WarehousePickup'" id="shipping-warehousepickup-note">{{ localizer.get("Checkout.Common.Shipping_WarehousePickup_Note") }}</div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset v-if="formData.shippingMode == 'ShippingAddress'" class="fieldset shippingdata-box" data-row="2" :disabled="isLoadingForm">
                        <div class="form-items" data-type="cols">
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingName" class="label">{{ localizer.get("Checkout.Common.Profile_Name") }}</label>
                                    <input type="text" id="ShippingName" v-model.lazy="formData.shippingName" :class="[{ 'input-validation-error': isValidationError('ShippingName') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingSurname" class="label">{{ localizer.get("Checkout.Common.Profile_Surname") }}</label>
                                    <input type="text" id="ShippingSurname" v-model.lazy="formData.shippingSurname" :class="[{ 'input-validation-error': isValidationError('ShippingSurname') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingAddress" class="label">{{ localizer.get("Checkout.Common.Profile_Address") }}</label>
                                    <input type="text" id="ShippingAddress" v-model.lazy="formData.shippingAddress" :class="[{ 'input-validation-error': isValidationError('ShippingAddress') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item"></div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingLocation" class="label">{{ localizer.get("Checkout.Common.Profile_Location") }}</label>
                                    <input type="text" id="ShippingLocation" v-model.lazy="formData.shippingLocation" :class="[{ 'input-validation-error': isValidationError('ShippingLocation') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingPostCode" class="label">{{ localizer.get("Checkout.Common.Profile_PostCode") }}</label>
                                    <input type="text" id="ShippingPostCode" v-model.lazy="formData.shippingPostCode" :class="[{ 'input-validation-error': isValidationError('ShippingPostCode') }, 'textbox']" />
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="control">
                                    <label for="ShippingCountry" class="label">{{ localizer.get("Checkout.Common.Profile_Country") }}</label>
                                    <select id="ShippingCountry" v-model.lazy="formData.shippingCountry" :class="[{ 'input-validation-error': isValidationError('ShippingCountry') }, 'dropdown']">
                                        <option :value="null">...</option>
                                        <option v-for="(shippingAddressCountry, index) in shippingAddressCountries" :value="shippingAddressCountry.value" :key="index">
                                            {{ shippingAddressCountry.title }}
                                        </option>
                                    </select>
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                            <div v-if="formData.shippingCountry == 'IT'" class="item">
                                <div class="control">
                                    <label for="ShippingZoneBox" class="label">{{ localizer.get("Checkout.Common.Profile_Provinces") }}</label>
                                    <select id="ShippingZoneBox" v-model.lazy="formData.shippingZone" :class="[{ 'input-validation-error': isValidationError('ShippingZone') }, 'dropdown']">
                                        <option :value="null">...</option>
                                        <option v-for="(shippingZone, index) in provinces" :value="shippingZone.value" :key="index">
                                            {{ shippingZone.title }}
                                        </option>
                                    </select>
                                    <span class="valid-sign">*</span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset class="fieldset mrg" data-mrgt="20" :disabled="isLoadingForm">
                        <legend class="legend">{{ localizer.get("Checkout.Common.Profile_DeclarationConsent") }}</legend>
                        <div class="form-items mrg" data-mrgt="20" data-type="privacy">
                            <div class="item">
                                <div class="checkbox">
                                    <input type="checkbox" name="IsCheckoutValidated" id="IsCheckoutValidated" v-model="formData.isCheckoutValidated">
                                    <label for="IsCheckoutValidated">{{ localizer.get("Checkout.Common.Profile_PrivacyDisclaimer_Text") }}</label>
                                    <span class="disclaimer"><a :href="routes.Terms_PrivacyPolicy" target="_blank" class="button-privacy">{{ localizer.get("Checkout.Common.Profile_PrivacyDisclaimer_Button") }}</a></span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset class="fieldset mrg" data-mrgt="20">
                        <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                            <ul>
                                <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                            </ul>
                        </div>
                        <div class="form-items" data-type="buttons">
                            <div class="item calltoaction">
                                <button id="ButtonSubmit" class="button" @click="submitForm()" :disabled="isLoadingForm"><span class="lable">{{ localizer.get("Account.Common.Button_Next") }}</span></button>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isLoadingForm = ref(false);
const formData = ref<any>({
    isCheckoutValidated: false
});
const validationErrors = ref<any[]>([]);
const profileTaxTypes = ref<any[]>([]);
const countries = ref<any[]>([]);
const provinces = ref<any[]>([]);
const shippingModes = ref<any[]>([]);
const shippingAddressCountries = ref<any[]>([]);

async function getData() {
    const response = (await Axios.post(routes.Account_ProfileEdit_GetData)).data;

    formData.value = response.profile;
    profileTaxTypes.value = response.profileTaxTypes;
    countries.value = response.countries;
    provinces.value = response.provinces;
    shippingAddressCountries.value = response.shippingAddressCountries;

    if (formData.value.country) {
        await getShippingModes();
    }

    isLoading.value = false;
}

onBeforeMount(async () => {
    await getData();
});

async function getShippingModes() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        const response = (await Axios.post(routes.Account_ProfileEdit_GetShippingModes, { countryCode: formData.value.country })).data;

        shippingModes.value = response;

        if (shippingModes.value.length === 1) {
            formData.value.shippingMode = shippingModes.value[0].value;
        }
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        await Axios.post(routes.Account_ProfileEdit, formData.value);

        GTagHelper.sendEvent("form_submit", "account_profileedit");

        window.location.href = routes.Account_StatusMessage + "?messageType=Update";
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>
